import Button from "../../utils/components/Button";
import Input from "../../utils/components/Input";
import WSLogo from "../../static/crane-ws-login-logo.svg";
import API from "../../utils/API";
import { useState } from "react";
import toastr from "toastr";
import inputValidations from "../../utils/helpers/inputValidations";

const ForgotPassword = ({ translate }) => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) return false;

    if (!inputValidations(email, "email")) {
      toastr.error(translate("auth.forgot_password.invalid_email"));
      return false;
    }

    API.postData("auth/forgot_password", { email })
      .then(({ data: res }) => {
        toastr.success(res.message);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="forgotPassword container-fluid d-flex flex-column align-items-center justify-content-center px-3 py-1">
      <div className="row d-flex align-items-center justify-content-center mt-5">
        <div className="col-md-12 col-lg-6 d-flex flex-column align-items-center mt-4">
          <img height={145} src={WSLogo} alt="logo" />
          <p className="fw-bold text-center my-4 pt-3 fs-5">
            {translate("auth.forgot_password.title")}
          </p>
        </div>
        <div className="col-md-12 col-lg-8">
          <form onSubmit={handleSubmit}>
            <Input
              type="email"
              name="email"
              value={email}
              className="d-block border-dark p-3"
              placeholder="Email"
              required={true}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button type="submit" className="btn-orange w-100 mt-3 p-2">
              {translate("auth.forgot_password.form_button")}
            </Button>
          </form>
        </div>
      </div>
      <div className="row w-100 mt-auto">
        <div className="d-flex flex-wrap align-items-center justify-content-between mt-auto">
          <p>Copyright © 2022</p>
          <p>Terms and Conditions</p>
          <p>Social Media Icons</p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
